const alertList = {
  state: () => ({
    /** 進階搜尋按鈕啟用 */
    advanceSearchButtonEnable: false,

    /** 進階搜尋對話框開啟或關閉 */
    advanceSearchDialog: false,

    /** 燈號圖表對話框開關 */
    lampChartDialogVisible: false,

    /** 處理對話框開關 */
    advanceHandleDialogVisible: false,

    /** 警報列表 */
    alertList: [],
  }),

  mutations: {
    /** 進階搜尋按鈕啟用 設值 */
    setAdvanceSearchButtonEnable(state, value) {
      state.advanceSearchButtonEnable = value;
    },

    /** 進階搜尋對話框開啟或關閉 設值 */
    setAdvanceSearchDialog(state, value) {
      state.advanceSearchDialog = value;
    },

    /** 燈號圖表對話框開關 設值 */
    setLampChartDialogVisible(state, value) {
      state.lampChartDialogVisible = value;
    },

    /** 處理對話框開關 設值 */
    setAdvanceHandleDialogVisible(state, value) {
      state.advanceHandleDialogVisible = value;
    },

    /** 警報列表 設值 */
    setAlertList(state, value) {
      state.alertList = value;
    },
  },
};

export default alertList;
